import {  Form, Formik } from 'formik'
import React from 'react'
import { useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import InputCom from 'src/components/Common/Input';
import Button from 'src/components/UI/Button';
import { updateAdjustmentPointLoading } from 'src/store/actions';
import * as Yup from 'yup';

const UpdateAdjustmentPoint = ({details,id,disabled}:any) => {
const dispatch=useDispatch()
    const initialvalue={
        adjustedAmount:details?.adjustedAmount ? JSON.parse(JSON.stringify(details?.adjustedAmount)) : "",
        adjustmentNotes:details?.adjustmentNotes ? JSON.parse(JSON.stringify(details?.adjustmentNotes)) : "",
    }

    const handleSubmit=(values:any)=>{
        
        dispatch(updateAdjustmentPointLoading(values,id))
    }

    const validationSchema=Yup.object().shape({
        adjustedAmount:Yup.number().required('Adjustment Point is required')
        .min(0, 'Adjustment Point cannot be negative'),
        adjustmentNotes:Yup.string().required('Adjustment Notes is required'),
    })

    const handleReset = (setFieldValue: any,setFieldTouched:any) => {
        setFieldValue('adjustedAmount',details?.adjustedAmount)
        setFieldValue('adjustmentNotes', details?.adjustmentNotes)
        setFieldTouched('adjustedAmount',false)
        setFieldTouched('adjustmentNotes',false)
      }

  return (

      <React.Fragment>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialvalue}
          validationSchema={validationSchema}
          enableReinitialize>
          {({ values, handleChange, touched, errors, handleBlur, resetForm,setFieldValue,setFieldTouched, reset, ...rest }: any) => {
            return (
              <Form onChange={handleChange}>
                <Row className=''>
                  <Col lg={4} className='mb-2'>
                    <InputCom labelName="Adjust Amount"
                      inputclassName="form-control"
                      labelClassName="form-Label"
                      type="number"
                      name="adjustedAmount"
                      onBlur={handleBlur}
                      value={values.adjustedAmount}
                      onChange={handleChange}
                      isRequired={true}
                      disabled={disabled}
                      invalid={touched["adjustedAmount"] && errors["adjustedAmount"] ? true : false}
                    />

                  </Col>



                  <Col lg={4} className='mb-2'>
                    <InputCom labelName="Adjustment Note"
                      inputclassName="form-control"
                      labelClassName="form-Label"
                      type="textarea"
                      name="adjustmentNotes"
                      onBlur={handleBlur}
                      value={values.adjustmentNotes}
                      onChange={handleChange}
                      isRequired={true}
                      disabled={disabled}
                      invalid={touched["adjustmentNotes"] && errors["adjustmentNotes"] ? true : false}
                    />

                  </Col>
                 
                 
                  <Col lg={4} className='d-flex justify-content-end align-items-center'>
                  {/* <div className="d-flex justify-content-end align-items-center"> */}
                    <Button
                      className="secondary-btn me-2"
                      label="Reset"
                      type="reset"
                      onClick={() => handleReset(setFieldValue,setFieldTouched)}
                    />
                    <Button
                      className="btn-primary me-2 btn-primary-shadow"
                      label="Update"
                      type="submit"
                      disabled={disabled}
                    />
                    {/* </div> */}
                    </Col>
   
                </Row>


              </Form>
            )
          }}
        </Formik>
      </React.Fragment>

  )
}

export default UpdateAdjustmentPoint